export default "__VITE_ASSET__DmfGwvmb__"